import { useEffect, useState } from 'preact/hooks';

export function useElementRect<T extends HTMLElement>(
  ref: preact.RefObject<T>
) {
  const [rect, setRect] = useState<DOMRect | null>(null);

  function updateRect() {
    if (ref.current) {
      setRect(ref.current.getBoundingClientRect());
    }
  }

  useEffect(() => {
    const controller = new AbortController();

    updateRect();

    window.addEventListener('scroll', updateRect, {
      passive: true,
      signal: controller.signal
    });
    window.addEventListener('resize', updateRect, controller);

    return () => controller.abort();
  }, []);

  return rect;
}
